export default __webpack_public_path__ + "static/media/zone-24_w.7bdb4655.svg";